<div class="transporter-selection-modal-root" [class.embedded]="embedded">
  <div class="dialogTitleBar" *ngIf="!embedded">
    <h2 class="dialogTitle">Select Transporters</h2>
    <button type="button" class="closeDialogBtn" (click)="handleClose()" aria-label="Close">
      <img src="/assets/images/cross-button.svg" alt="" width="20" height="20" />
    </button>
  </div>

  <div class="modalContent">
    <div class="modalBody">
      <div *ngIf="isLoading" class="loadingState">
        <p class="loadingText">Loading transporters...</p>
      </div>

      <div *ngIf="!isLoading" class="modalGrid">
        <!-- Available -->
        <div class="modalPanel">
          <div class="panelHeader">
            <div class="panelHeaderRow">
              <div class="panelTitleWrapper">
                <h3 class="panelTitle">Available Transporters</h3>
                <span class="countBadge">({{ allTransporters.length }})</span>
              </div>
              <div class="panelActions">
                <button
                  type="button"
                  class="iconButton"
                  title="Export All Transporters"
                  [disabled]="allTransporters.length === 0 || isLoading"
                  (click)="handleExportTransporters()"
                >
                  <svg class="iconSvg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                </button>
                <button
                  type="button"
                  class="iconButton"
                  title="Upload Transporters"
                  [disabled]="isLoading || isUploading"
                  (click)="handleUploadClick(fileInput)"
                >
                  <mat-spinner *ngIf="isUploading" diameter="16" class="uploadSpinner"></mat-spinner>
                  <svg *ngIf="!isUploading" class="iconSvg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="17 8 12 3 7 8" />
                    <line x1="12" y1="3" x2="12" y2="15" />
                  </svg>
                </button>
                <button
                  *ngIf="filteredAllTransporters.length > 0"
                  type="button"
                  class="selectAllButton"
                  (click)="selectAllFiltered()"
                >
                  Select All
                </button>
              </div>
            </div>
            <input
              #fileInput
              type="file"
              accept=".xls,.xlsx,.xlsm,.csv"
              class="hiddenFileInput"
              (change)="onFileSelected($event)"
            />
            <div class="searchWrapper">
              <img class="searchIconImg" src="/assets/images/search.svg" width="16" height="16" alt="" />
              <input
                type="text"
                placeholder="Search..."
                [(ngModel)]="searchLeft"
                class="searchInput"
              />
            </div>
          </div>
          <div class="panelContent">
            <div *ngIf="filteredAllTransporters.length === 0" class="emptyState">
              <p class="emptyText">
                {{ searchLeft ? 'No transporters found' : 'No transporters available' }}
              </p>
            </div>
            <button
              *ngFor="let transporter of filteredAllTransporters"
              type="button"
              class="transporterItem"
              (click)="addTransporter(transporter)"
            >
              <span>{{ transporter.name }}</span>
              <svg class="addIcon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Selected -->
        <div class="modalPanel">
          <div class="panelHeader">
            <div class="panelHeaderRow">
              <div class="panelTitleWrapper">
                <h3 class="panelTitle">Selected Transporters</h3>
                <span class="countBadge">({{ getSelectedCount() }})</span>
              </div>
              <button
                *ngIf="selectedTransporters.length > 0"
                type="button"
                class="clearButton"
                (click)="clearAllSelected()"
              >
                Clear all
              </button>
            </div>
            <div class="searchWrapper">
              <img class="searchIconImg" src="/assets/images/search.svg" width="16" height="16" alt="" />
              <input
                type="text"
                placeholder="Search..."
                [(ngModel)]="searchRight"
                class="searchInput"
              />
            </div>
          </div>
          <div class="panelContent">
            <div *ngIf="filteredSelectedTransporters.length === 0" class="emptyState">
              <p class="emptyText">
                No transporters selected.<br />
                Click items from the left to add.
              </p>
            </div>
            <div *ngFor="let transporter of filteredSelectedTransporters" class="selectedItem">
              <span>{{ transporter.name }}</span>
              <button
                type="button"
                class="removeButton"
                (click)="removeTransporter(transporter.id)"
                aria-label="Remove"
              >
                <svg class="removeIcon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modalFooter" *ngIf="!embedded">
      <button type="button" class="btnSecondary" (click)="handleClose()">Cancel</button>
      <button type="button" class="btnPrimary" [disabled]="getSelectedCount() === 0" (click)="handleSave()">
        Add ({{ getSelectedCount() }})
      </button>
    </div>
  </div>
</div>
